import { FunctionComponent, RefObject } from "react";

import { Tooltip, TooltipProps } from "primereact/tooltip";

interface ITooltipWrapperProps extends TooltipProps {
  targetRef?: RefObject<HTMLElement | null> | string;
  tooltipRef?: RefObject<Tooltip | null>;
}

export const TooltipWrapper: FunctionComponent<ITooltipWrapperProps> = (props: ITooltipWrapperProps) => {
  if (!props?.targetRef) {
    return;
  }

  const tooltipProps = { ...props };

  const target =
    typeof tooltipProps.targetRef === "string"
      ? tooltipProps.targetRef
      : (tooltipProps.targetRef?.current ?? undefined);

  // Remove custom props to avoid passing them to Tooltip component
  delete tooltipProps.targetRef;

  if (props.tooltipRef) {
    delete tooltipProps.tooltipRef;
  }

  return <Tooltip {...tooltipProps} ref={props.tooltipRef} target={target} />;
};
